/* eslint-disable max-len */
var UI_CHEVRON_LEFT = {
  "default": 'M25.05,29.8a1.26,1.26,0,1,1-1.68,1.88L7,16.94a1.26,1.26,0,0,1,0-1.88L23.37.32h0A1.26,1.26,0,1,1,25.05,2.2L9.68,16Z',
  globetrotter: 'M22.75 29.5L9.25 16L22.75 2.5'
};

export { UI_CHEVRON_LEFT };
//# sourceMappingURL=UI_CHEVRON_LEFT.js.map
